import { createSelector } from '@reduxjs/toolkit';
import { selectFiltersAvailability } from './selectFiltersAvailability';

export const selectShowMarketTrendsByFilters = createSelector(
  selectFiltersAvailability,
  ({ supplyDemandShow, ...restFilters }) => ({
    showSupplyDemand: supplyDemandShow,
    showPriceDynamic: Object.values(restFilters).some(Boolean),
  }),
);
